import _mixin from '../_mixin'

export default {
  name: 'SVersionFooter',
  cnName: '页脚类',
  type: 'activity_version',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/11/2ca3d0c9ca3a7379b324921bd0e3ef84.png',
      style: {
        width: '1920px',
        height: '282px'
      }
    }
  },
  propsDesc: [
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
